<style scoped>
    .date-picker-container{
        display: inline-block;
        width: 200px;
    }
    .search-input{
        display: inline-block;
        min-width: 250px;
        max-width: 600px;
    }
    .edit-title{
        font-size: 22px;
    }
    .form-title{
        margin: 5px 0;
        padding: 0 5px;
    }
    .director-label{
        display: inline-block;
        width: 100%;
        height: 32px;
        line-height: 32px;
        border: 1px solid #dddee1;
        border-radius: 4px;
    }
    .error-line{
        color: red;
    }
    .ivu-radio, .ivu-radio-wrapper{
        margin: 0;
    }
    .career-title{
        font-size: 20px;
        font-weight: bold;
    }
    .career-quit{
        margin-left: 20px;
        font-size: 17px;
    }
    .ivu-cascader{
        display: inline-block;
    }
    .search-director-poptip{
        display: block;
    }
    .search-director-poptip /deep/ .ivu-poptip-rel{
        display: block;
    }
    .set-director-btn{
        margin-bottom: 3px;
    }
    .id-checkbox{
        padding: 8px;
    }
</style>
<template>
  <div>
    <div class="line text-center">
      <Button
        type="primary"
        icon="md-add"
        @click="editCustomer(new_customer)"
      >
        添加
      </Button>
      <Select
        v-model="params.time_item"
        placeholder="日期维度"
        style="width: 100px"
      >
        <Option value="contract_start">
          入职日期
        </Option>
        <Option value="contract_end">
          合同到期日
        </Option>
        <Option value="quit_time">
          离职日期
        </Option>
      </Select>
      <div class="date-picker-container">
        <DatePicker
          type="daterange"
          :options="date_option"
          placement="bottom-start"
          placeholder="日期范围"
          @on-change="setStartAndEnd"
        />
      </div>
      <Select
        v-model.number="params.quit"
        placeholder="是否在职"
        style="width: 100px"
        @on-change="doSearch"
      >
        <Option :value="0">
          在职
        </Option>
        <Option :value="1">
          离职
        </Option>
        <Option :value="2">
          所有员工
        </Option>
      </Select>
      <Cascader
        :data="customer_type_data"
        placeholder="员工类别(默认所有类别)"
        style="width: 200px"
        @on-change="customerTypeSelect"
      />
    </div>

    <div class="line text-center">
      <Select
        v-if="companies.length"
        v-model.number="params.company_id"
        placeholder="公司"
        style="width: 150px"
        @on-change="doSearch"
      >
        <Option :value="0">
          所有公司
        </Option>
        <Option
          v-for="company in companies"
          :key="company.id"
          :value="company.id"
        >
          {{ company.short_name }}
        </Option>
      </Select>
      <Select
        v-model.number="params.team_id"
        filterable
        clearable
        placeholder="选择团队"
        style="width: 150px"
        @on-change="doSearch"
      >
        <Option :value="0">
          所有团队
        </Option>
        <Option
          v-for="team in teams"
          :key="team.id"
          :value="team.id"
        >
          {{ team.full_name }}
        </Option>
      </Select>
      <Select
        v-if="jobs.length"
        v-model.number="params.job_id"
        filterable
        clearable
        placeholder="选择岗位"
        style="width: 150px"
        @on-change="doSearch"
      >
        <Option :value="0">
          所有岗位
        </Option>
        <Option
          v-for="job in jobs"
          v-show="!job.del"
          :key="job.id"
          :value="job.id"
        >
          {{ job.name }}
        </Option>
      </Select>
      <Select
        v-model.number="params.office_id"
        placeholder="工作地点"
        style="width: 100px"
        @on-change="doSearch"
      >
        <Option :value="0">
          所有地点
        </Option>
        <Option :value="1">
          成都
        </Option>
        <Option :value="2">
          北京
        </Option>
        <Option :value="3">
          远程
        </Option>
      </Select>
      <div class="search-input">
        <i-input
          v-model="params.search"
          placeholder="请输入搜索关键字"
          @on-enter="doSearch"
        />
      </div>
      <Ajaxbtn
        ref="searchBtn"
        :url="get_customers_path"
        :params="params"
        type="search"
        @before="beforeSearch"
        @done="handleData"
        @fail="handleFail"
      />
    </div>

    <div class="list-container">
      <Table
        ref="table"
        border
        :columns="customer_columns"
        :data="customers"
        :no-data-text="empty_tip"
        size="small"
      />
      <Backdrop v-show="loading" />
    </div>

    <div
      v-show="page_info.total"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>

    <Modal
      v-model="edit_config.modal"
      width="750"
      title="添加 / 编辑"
      ok-text="保存"
      :loading="edit_config.loading"
      @on-ok="editOK"
    >
      <div class="line edit-title">
        <Icon type="ios-person" />
      </div>
      <Row>
        <i-col span="8">
          <Select
            v-model="edit_customer.customer_type"
            placeholder="员工类别"
          >
            <Option
              v-for="item in customer_types"
              :key="item.key"
              :value="item.key"
            >
              {{ item.label }}
            </Option>

            <!-- <Option :value="0">
              正式员工
            </Option>
            <Option :value="1">
              正式员工-实习
            </Option>
            <Option :value="10">
              实习生
            </Option>
            <Option :value="20">
              兼职/外包
            </Option>
            <Option :value="30">
              挂靠人员
            </Option>
            <Option :value="100">
              公共账号
            </Option> -->
          </Select>
        </i-col>
        <i-col span="8">
          <i-input v-model.trim="edit_customer.account">
            <span slot="prepend">姓名</span>
            <Radio-group
              slot="append"
              v-model="edit_customer.gender"
            >
              <Radio :label="1">
                <Icon
                  type="md-male"
                  color="#57a3f3"
                />
              </Radio>
              <Radio :label="0">
                <Icon
                  type="md-female"
                  color="#f768a7"
                />
              </Radio>
            </Radio-group>
          </i-input>
        </i-col>
        <i-col span="8">
          <i-input v-model.trim="edit_customer.uid">
            <span slot="prepend">工号</span>
            <span
              v-show="!edit_customer.uid"
              slot="append"
            >
              <Button @click="getAutoUid()">编号</Button>
            </span>
          </i-input>
        </i-col>
      </Row>
      <div class="line" />
      <Row>
        <i-col span="8">
          <i-input v-model.trim="edit_customer.mobile">
            <span slot="prepend">手机</span>
          </i-input>
        </i-col>
        <i-col span="8">
          <i-input v-model.trim="edit_customer.email">
            <span slot="prepend">邮箱</span>
          </i-input>
        </i-col>
        <i-col span="8">
          <i-input v-model.trim="edit_customer.id_number">
            <span slot="prepend">身份证</span>
          </i-input>
        </i-col>
      </Row>
      <div class="line" />
      <Row>
        <i-col span="8">
          <i-input v-model.trim="edit_customer.qq_number">
            <span slot="prepend">QQ</span>
          </i-input>
        </i-col>
        <i-col span="8">
          <i-input v-model.trim="edit_customer.wechat_number">
            <span slot="prepend">微信</span>
          </i-input>
        </i-col>
        <i-col span="8">
          <Checkbox
            v-model="edit_customer.has_id_material"
            class="id-checkbox"
          >
            是否已提交身份证资料
          </Checkbox>
        </i-col>
      </Row>
      <div class="error-line">
        <span v-if="err_msg.mobile">{{ err_msg.mobile }}</span>
      </div>
      <div class="line edit-title">
        <Icon type="ios-people" />
      </div>
      <Row>
        <i-col span="6">
          <div class="form-title">
            公司
          </div>
          <Select
            v-if="companies.length"
            v-model="edit_customer.company_id"
            transfer
            placeholder="选择公司"
          >
            <Option
              v-for="c in companies"
              :key="c.id"
              :value="c.id"
            >
              {{ c.short_name }}
            </Option>
          </Select>
        </i-col>
        <i-col span="6">
          <div class="form-title">
            团队
          </div>
          <Select
            v-if="teams.length"
            v-model="edit_customer.team_id"
            filterable
            transfer
            clearable
            placeholder="选择团队"
          >
            <Option
              v-for="t in teams"
              :key="t.id"
              :value="t.id"
            >
              {{ t.full_name }}
            </Option>
          </Select>
        </i-col>
        <i-col span="6">
          <div class="form-title">
            岗位
          </div>
          <Select
            v-if="jobs.length"
            v-model="edit_customer.job_id"
            transfer
            filterable
            clearable
            placeholder="选择岗位"
          >
            <Option
              v-for="j in jobs"
              v-show="!j.del"
              :key="j.id"
              :value="j.id"
            >
              {{ j.name }}
            </Option>
          </Select>
        </i-col>
        <i-col span="6">
          <div class="form-title">
            工作地点
          </div>
          <Select
            v-if="offices.length"
            v-model="edit_customer.office_id"
            transfer
            placeholder="工作地点"
          >
            <Option
              v-for="o in offices"
              :key="o.id"
              :value="o.id"
            >
              {{ o.name }}
            </Option>
          </Select>
        </i-col>
      </Row>
      <Row v-show="edit_customer.customer_type !== 'official'">
        <i-col span="6">
          <div class="form-title">
            负责人
          </div>
          <Poptip
            class="search-director-poptip"
            transfer
            placement="bottom"
            width="300"
          >
            <Button long>
              {{ edit_customer.director || '无负责人' }}
            </Button>
            <div slot="content">
              <i-input
                v-model="search_director_text"
                size="small"
                placeholder="搜索负责人"
                @on-enter="searchDirector"
              >
                <Button
                  slot="append"
                  icon="ios-search"
                  :loading="search_director_loading"
                  @click="searchDirector"
                >
                  搜索
                </Button>
              </i-input>
              <div class="line">
                <Button
                  v-for="c in searched_directors"
                  :key="c.id"
                  class="set-director-btn"
                  size="small"
                  long
                  @click="setCustomerDirector(c)"
                >
                  {{ c.account + '-' + c.uid }}
                </Button>
              </div>
            </div>
          </Poptip>
        </i-col>
        <i-col span="6">
          <div class="form-title">
            税前日薪(RMB)
          </div>
          <i-input
            v-model="edit_customer.daily_wage"
            number
          />
        </i-col>
        <i-col
          v-show="edit_customer.customer_type === 10"
          span="6"
        >
          <div class="form-title">
            学生证到期日
          </div>
          <DatePicker
            v-model="edit_customer.student_expire"
            type="date"
            placeholder="请选择..."
            @on-change="studentExpireChange"
          />
        </i-col>
      </Row>
      <div class="line edit-title">
        <Icon type="md-home" />
      </div>
      <Row>
        <i-col span="12">
          <i-input v-model.trim="edit_customer.school">
            <span slot="prepend">学校</span>
          </i-input>
        </i-col>
        <i-col span="12">
          <i-input v-model.trim="edit_customer.faculty">
            <span slot="prepend">学院</span>
          </i-input>
        </i-col>
      </Row>
      <div class="line" />
      <Row>
        <i-col span="12">
          <div class="text-center">
            <Select
              v-model="edit_customer.degree"
              style="width:48%"
              transfer
              placeholder="学历"
            >
              <Option
                v-for="degree in degrees"
                :key="degree"
                :value="degree"
              >
                {{ degree }}
              </Option>
            </Select>
            <Select
              v-model="edit_customer.grade"
              style="width:48%"
              transfer
              placeholder="年级"
            >
              <Option
                v-for="grade in grades"
                :key="grade"
                :value="grade"
              >
                {{ grade }}
              </Option>
            </Select>
          </div>
        </i-col>
        <i-col span="12">
          <i-input v-model.trim="edit_customer.major">
            <span slot="prepend">专业</span>
            <Select
              slot="append"
              v-model="edit_customer.major_attr"
              transfer
              style="width: 80px"
            >
              <Option
                v-for="attr in major_attr_arr"
                :key="attr.value"
                :value="attr.value"
              >
                {{ attr.content }}
              </Option>
            </Select>
          </i-input>
        </i-col>
      </Row>
      <div class="line edit-title">
        <Icon type="ios-card" />
      </div>
      <Row class="line">
        <i-col span="12">
          <i-input
            v-model.trim="edit_customer.bank"
            placeholder="只能是招商银行"
          >
            <span slot="prepend">银行</span>
          </i-input>
        </i-col>
        <i-col span="12">
          <i-input v-model.trim="edit_customer.bank_branch">
            <span slot="prepend">支行</span>
          </i-input>
        </i-col>
      </Row>
      <Row>
        <i-col span="12">
          <i-input v-model.trim="edit_customer.bank_number">
            <span slot="prepend">卡号</span>
          </i-input>
        </i-col>
        <i-col span="12">
          <i-input v-model.trim="edit_customer.alipay">
            <span slot="prepend">支付宝</span>
          </i-input>
        </i-col>
      </Row>
      <div class="line">
        <h4>个人简介</h4>
        <i-input
          v-model="edit_customer.intro"
          type="textarea"
          :autosize="{minRows: 3}"
          placeholder="个人简介..."
        />
      </div>
      <div class="line">
        <h4>备注</h4>
        <i-input
          v-model="edit_customer.desc"
          type="textarea"
          :rows="2"
          placeholder="备注..."
        />
      </div>
    </Modal>

    <Modal
      v-model="edit_career_config.modal"
      width="750"
      title="编辑入离职/合同信息"
      ok-text="保存"
      :loading="edit_career_config.loading"
      @on-ok="editCareerOK"
    >
      <div class="line">
        <div class="line">
          <span
            class="career-title"
            :class="{'color-error': edit_customer.quit}"
          >{{ edit_customer.account }} </span>
          <span class="career-quit">
            <input
              v-model="edit_customer.quit"
              type="checkbox"
            >
            <label>是否离职</label>
          </span>
          <Button
            v-if="edit_customer.careers && !edit_customer.careers.length"
            type="primary"
            size="small"
            icon="md-add"
            @click="addCareer()"
          >
            添加
          </Button>
        </div>
        <table class="mis-table">
          <thead>
            <tr>
              <th width="80">
                加入试用期
              </th>
              <th width="80">
                是否转正
              </th>
              <th>合同开始</th>
              <th>合同结束</th>
              <th>离职时间</th>
              <th>备注</th>
              <th width="65">
                操作
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(career, index) in edit_customer.careers"
              :key="index"
            >
              <td>
                <Checkbox v-model="career.need_probation">
                  加入试用期
                </Checkbox>
              </td>
              <td>
                <Checkbox v-model="career.turn_regular">
                  转正
                </Checkbox>
              </td>
              <td>
                <DatePicker
                  v-model="career.contract_start"
                  type="date"
                  placeholder="合同开始"
                />
              </td>
              <td>
                <DatePicker
                  v-model="career.contract_end"
                  type="date"
                  placeholder="合同结束"
                />
              </td>
              <td>
                <DatePicker
                  v-model="career.quit_time"
                  type="date"
                  placeholder="离职时间"
                  @on-change="quitTimeChange"
                />
              </td>
              <td>
                <i-input
                  v-model="career.desc"
                  type="textarea"
                  placeholder="备注..."
                />
              </td>
              <td class="text-left">
                <Button
                  type="primary"
                  size="small"
                  icon="md-add"
                  @click="addCareer()"
                />
                <Poptip
                  confirm
                  placement="left"
                  title="您确认删除吗？"
                  @on-ok="delCareer(career, index)"
                >
                  <Button
                    type="warning"
                    size="small"
                    icon="md-close"
                  />
                </Poptip>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Modal>
    <CustomerDetail ref="detail" />
  </div>
</template>
<script route="/hr/customers">
  import Util from '../../libs/util';
  import CustomerExpand from './components/customer_expand';
  import CustomerDetail from './customer_detail';
  import DataUtil from 'view-design/src/utils/date';
  import { type_list, type_hash } from '@/views/hr/libs/util.js'
  import {mapGetters} from "vuex";

  export default {
    components: { CustomerExpand, CustomerDetail },
    data() {
      return {
        type_list,
        get_customers_path: Util.api.query_customer,
        empty_tip: '获取数据中...',
        customer_type_data: [
          {
            value: -1,
            label: '所有类别'
          },
          {
            value: '',
            label: '正式员工',
            children: [
              {
                value: 9,
                label: '所有正式'
              },
              {
                value: 0,
                label: '正式员工'
              },
              {
                value: 1,
                label: '正式员工-实习'
              }
            ]
          },
          {
            value: 10,
            label: '实习生'
          },
          {
            value: 20,
            label: '兼职/外包'
          },
          {
            value: 30,
            label: '挂靠人员'
          },
          {
            value: 100,
            label: '公共账号'
          },
        ],
        params: {
          per_page: 20,
          page: 1,
          search: '',
          customer_type: '-1',
          start: '',
          end: '',
          time_item: 'contract_start',
          quit: 0,
          team_id: 0,
          company_id: 0,
          job_id: 0,
          office_id: 0
        },
        page_info: {
          current: 1,
          total: 0,
          page_size: 20
        },
        directors_hash: {},
        degrees: ['专科', '本科', '硕士', '博士', '博士后'],
        grades: ['大一', '大二', '大三', '大四', '大五', '大六', '研一', '研二', '研三', '研四', '博一', '博二', '博三', '已毕业', '其他'],
        date_option: {
          shortcuts: [
            {
              text: '最近一周',
              value() {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                return [start, end];
              }
            },
            {
              text: '最近一个月',
              value() {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                return [start, end];
              }
            },
            {
              text: '最近三个月',
              value() {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                return [start, end];
              }
            },
            {
              text: '最近一年',
              value() {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                return [start, end];
              }
            }
          ]
        },
        customer_columns: [
          {
            title: '展开',
            type: 'expand',
            width: 50,
            render: (h, params) => {
              return h(CustomerExpand, {
                props: {
                  customer: params.row
                }
              })
            }
          },
          {
            title: '姓名/工号',
            width: 80,
            render: (h, params) => {
              const row = params.row;
              const ret = [];
              ret.push(h('a', {
                props: {
                  type: 'text',
                  size: 'small'
                },
                'class': {
                  'color-info': !row.quit,
                  'color-error': row.quit,
                },
                on: {
                  click: () => {
                    this.$refs.detail.show(row.id);
                  }
                }
              }, row.account));
              ret.push(h('div', row.uid));
              return h('div', ret);
            }
          },
          {
            title: '基本信息',
            render: (h, params) => {
              const row = params.row;
              const ret = [];
              const gender = params.row.gender ? '男' : '女';
              ret.push(h('div', '性别: ' + gender));
              ret.push(h('div', '手机: ' + (row.mobile || '无')));
              ret.push(h('div', '邮箱: ' + (row.email || '无')));
              ret.push(h('div', '身份证: ' + (row.id_number || '无')));
              ret.push(h('div', 'QQ: ' + (row.qq_number || '无')));
              ret.push(h('div', '微信: ' + (row.wechat_number || '无')));
              return h('div', ret);
            }
          },
          {
            title: '组织信息',
            width: 160,
            render: (h, params) => {
              const row = params.row;
              const ret = [];
              ret.push(h('div', '公司: ' + (row.company || '未设置')));
              ret.push(h('div', '团队: ' + (row.team || '未设置')));
              ret.push(h('div', '岗位: ' + (row.job || '未设置')));
              // ret.push(h('div', `员工类型:${type_hash[row.customer_type] || '未定义员工类型'}`))
              /* -----------员工类型---------- */
              
              if (this.customer_types_hash && this.customer_types_hash[row.customer_type]) {
                const current_customer = this.customer_types_hash[row.customer_type]
                ret.push(h('div', `员工类型:${current_customer.label || '未定义员工类型'}`))
              } else {
                ret.push(h('div', `员工类型:未定义员工类型`))
              }
              if (row.customer_type !== 'official') {
                ret.push(h('div', [
                  h('span', '负责人: ' + (row.director || '未设置')),
                  h('span', ' 税前日薪: ' + (row.daily_wage || '未设置'))
                ]));
              }
              if (row.office_id) {
                const office = this.offices_hash[row.office_id];
                if (office) {
                  ret.push(h('div', '工作地点: ' + office.name));
                }
              }
              return h('div', ret);
            }
          },
          {
            title: '学历信息',
            width: 200,
            render: (h, params) => {
              const row = params.row;
              const ret = [];
              ret.push(h('div', '学校: ' + (row.school || '未设置')));
              ret.push(h('div', '学历: ' + (row.degree || '未设置')));

              // let major_attr = '未设置';
              // switch (row.major_attr) {
              // case 0:
              //   major_attr = '英语类';
              //   break;
              // case 1:
              //   major_attr = '其他';
              //   break;
              // case 2:
              //   major_attr = '教育类';
              //   break;
              // case 3:
              //   major_attr = '心理类'
              // }
              ret.push(h('div', [
                h('span', '专业: ' + (row.major || '未设置')),
                //h('span', ' 属性: ' + major_attr)
              ]));
              if (row.customer_type !== 'official') {
                ret.push(h('div', '院系: ' + (row.faculty || '未设置')));
                ret.push(h('div', '年级: ' + (row.grade || '未设置')));
              }
              return h('div', ret);
            }
          },
          {
            title: '支付信息',
            width: 160,
            render: (h, params) => {
              const row = params.row;
              const ret = [];
              ret.push(h('div', '银行: ' + (row.bank || '-')));
              ret.push(h('div', '开户行: ' + (row.bank_branch || '-')));
              ret.push(h('div', '开户省: ' + (row.province || '-') + ' 市:' + (row.city || '-')));
              ret.push(h('div', '卡号: ' + (row.bank_number || '-')));
              ret.push(h('div', '支付宝: ' + (row.alipay || '-')));
              return h('div', ret);
            }
          },
          {
            title: '操作',
            key: 'action',
            align: 'center',
            width: 90,
            render: (h, params) => {
              const row = params.row;
              const ret = [];
              ret.push(h('Button', {
                props: {
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.editCustomer(row);
                  }
                }
              }, '基本信息'));
              ret.push(h('div', {
                'class': {
                  'hr': true
                }
              }));
              ret.push(h('Button', {
                props: {
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.editCareer(row);
                  }
                }
              }, '合同/离职'));
              return h('div', ret);
            }
          }
        ],
        customers: [],
        major_attr_arr: [
          {
            value: 0,
            content: '英语类'
          },
          {
            value: 2,
            content: '教育类'
          },
          {
            value: 3,
            content: '心理类'
          },
          {
            value: 1,
            content: '其他'
          },
        ],
        // 获取列表或者搜索时
        loading: false,
        edit_config: {
          modal: false,
          loading: true
        },
        err_msg: {},
        new_customer: {
          account: '',
          customer_type: 'intern',
          gender: 1,
          uid: '',
          email: null,
          entry_time: '',
          contract_deadline: '',
          mobile: '',
          company_id: 0,
          team_id: 0,
          job_id: 0,
          id_number: '',
          qq_number: '',
          wechat_number: '',
          director_id: 0,
          director: '',
          school: '',
          degree: '',
          grade: '',
          faculty: '',
          major: '',
          major_attr: 0,
          daily_wage: 120,
          has_id_material: false,
          student_expire: '',
          desc: '',
          intro: '',
          bank: '招商银行',
          bank_branch: '',
          bank_number: '',
          alipay: '',
          careers: [],
          quit: 0
        },
        edit_customer: {},
        edit_customer_rule: {},

        search_director_text: '',
        search_director_loading: false,
        searched_directors: [],

        edit_career_config: {
          modal: false,
          loading: true
        },
        new_career: {
          need_probation: false,
          turn_regular: false,
          entry_time: '',
          quit_time: '',
          contract_start: '',
          contract_end: '',
          desc: '',
        }
      }
    },
    computed: {
      ...mapGetters({
        companies: 'async/companies',
        companies_hash: 'async/companies_hash',
        teams: 'async/teams',
        teams_hash: 'async/teams_hash',
        jobs: 'async/jobs',
        jobs_hash: 'async/jobs_hash',
        offices: 'async/offices',
        offices_hash: 'async/offices_hash',
        customer_types: 'async/customer_types'
      }),
      customer_types_hash() {
        return this.customer_types.reduce((total, item) => {
          total[item.key] = item
          return total
        }, {})
      }
    },
    watch: {
      $route(route, oldRoute) {
        if (route.path === oldRoute.path) {
          this.params.page = 1;
          this.getCustomers();
        }
      }
    },
    created() {
      this.getCustomers();
    },
    methods: {
      getCustomers() {
        if (!this.loading) {
          this.loading = true;
          this.empty_tip = '获取数据中...';
          Util.ajax.get(this.get_customers_path, {
            params: this.params
          }).then((response) => {
            return response.data;
          }).then((res) => {
            if (res.code === 1) {
              this.handleData(res.data);
            } else {
              this.$Modal.error({
                title: '错误',
                content: res.msg
              });
            }
          }).catch((e) => {
            this.loading = false;
            this.empty_tip = '获取数据失败, 请刷新页面重试';
            console.log(e);
          });
        }
      },
      doSearch() {
        this.$refs.searchBtn.doAjax();
      },
      getAutoUid() {
        let head_num;
        if (this.edit_customer.customer_type === 'official') {
          switch (this.edit_customer.company_id) {
          case 1:
            head_num = 1;
            break;
          case 2:
            head_num = 2;
            break;
          case 3:
            head_num = 3;
            break;
          default:
            this.$Message.warning('请选择公司后再编号!');
            return;
          }
        } else if (this.edit_customer.customer_type === 10) {
          head_num = 4;
        } else if (this.edit_customer.customer_type === 20) {
          head_num = 5;
        } else if (this.edit_customer.customer_type === 30) {
          head_num = 6;
        } else if (this.edit_customer.customer_type === 100) {
          head_num = 9;
        } else {
          this.$Message.warning('请选择员工类型!');
          return;
        }
        Util.ajax.get('customer/get_auto_uid', {
          params: {
            head_num: head_num
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            this.edit_customer.uid = res.data;
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
        });
      },
      customerTypeSelect(value_arr) {
        console.log(value_arr);
        this.params.customer_type = value_arr[value_arr.length - 1] || -1;
        this.doSearch();
      },
      getDirector(director_id) {
        return this.directors_hash[director_id];
      },
      pageChange(new_page) {
        this.params.page = new_page;
        this.getCustomers();
      },
      beforeSearch() {
        this.params.page = 1;
        this.loading = true;
        this.empty_tip = '搜索结果中...';
        this.customers = [];
      },
      handleData(data) {
        this.loading = false;
        this.customers = [];
        this.directors_hash = data.directors;
        data.customers.forEach((customer) => {
          this.preHandleCustomer(customer);
          this.customers.push(customer);
        });
        if (data.customers.length === 0) {
          this.empty_tip = '没有结果, 请重试!';
        }
        this.page_info.current = data.cur_page;
        this.page_info.page_size = data.per_page;
        this.page_info.total = data.total_count;
      },
      handleFail(e) {
        this.loading = false;
        this.empty_tip = '搜索失败, 请重试';
        console.log(e);
      },
      preHandleCustomer(customer) {
        if (this.params.start || this.params.end) {
          customer._expanded = true;
        }
        customer.gender = customer.gender ? 1 : 0;
        customer.director = this.directors_hash[customer.director_id] || '-';
      },
      searchDirector() {
        if (!this.search_director_loading) {
          this.search_director_loading = true;
          Util.ajax.get('customer/query_name', {
            params: {
              search: this.search_director_text,
              quit_status: 0
            }
          }).then((response) => {
            return response.data;
          }).then((res) => {
            this.search_director_loading = false;
            if (res.code === 1) {
              const data = res.data;
              this.searched_directors = data;
            } else {
              this.$Modal.warning({
                title: '提示',
                content: res.msg
              })
            }
          }).catch((e) => {
            this.search_director_loading = true;
            console.log(e);
          });
        }
      },
      setStartAndEnd(date) {
        this.params.start = date[0];
        this.params.end = date[1];
      },
      editCustomer(customer_data) {
        this.edit_customer = Util.clone(customer_data);
        this.edit_config.modal = true;
      },
      setCustomerDirector(director) {
        this.edit_customer.director_id = director.id;
        this.edit_customer.director = director.account;
        this.directors_hash[director.id] = director.account;
        document.body.click();
      },
      editOK() {
        if (this.checkCustomerValid()) {
          this.updateCustomer();
        }
      },
      checkCustomerValid() {
        let msg = '';
        const id_number = this.edit_customer.id_number;
        // 小于14位一般是护照号, 没有办法校验正确性, 跳过校验
        if (id_number && id_number.length >= 14 && !Util.IDCheck(id_number)) {
          msg += '<p>身份证有误, 请仔细检查!</p>';
          this.$Modal.error({title: '错误', content: msg});
          this.edit_config.loading = false;
          setTimeout(() => {
            this.edit_config.loading = true;
          }, 500);
          return false;
        }
        if (this.edit_customer.bank_number && !Util.LuhnCheck(this.edit_customer.bank_number)) {
          msg += '<p>银行卡号可能有误, 你确定要提交吗?</p>';
          this.$Modal.confirm({
            title: '提示',
            content: msg,
            onOk: () => {
              this.updateCustomer();
            },
            onCancel: () => {
              this.edit_config.loading = false;
              setTimeout(() => {
                this.edit_config.loading = true;
              }, 500);
            }
          });
          return false;
        }
        /*if(this.edit_customer.bank_number.length !== 16){
                    msg += '<p>招行卡应为16位数据!</p>';
                    this.$Modal.error({title: '错误', content: msg});
                    this.edit_config.loading = false;
                    setTimeout(()=>{
                        this.edit_config.loading = true;
                    }, 500);
                    return false;
                }*/
        return true;
      },
      updateCustomer() {
        Util.ajax.post(Util.api.update_customer, this.edit_customer).then((response) => {
          console.log(response);
          return response.data;
        }).then((data) => {
          console.log(data);
          if (data.code === 1) {
            this.edit_config.modal = false;
            this.insertOrUpdateCustomer(data.customer);
            this.$Message.success({
              content: '操作成功!'
            });
          } else {
            this.edit_config.loading = false;
            setTimeout(() => {
              this.edit_config.loading = true;
            }, 500);
            let content = '';
            if (Util.isObject(data.msg)) {
              for (const key in data.msg) {
                content += '<p>' + data.msg[key] + '</p>';
              }
            } else {
              content = data.msg;
            }
            setTimeout(() => {
              this.$Modal.error({
                title: '提示',
                content: content
              });
            }, 500);
          }
        }).catch((e) => {
          this.edit_config.loading = false;
          setTimeout(() => {
            this.edit_config.loading = true;
          }, 500);
          console.log(e);
          this.$Message.error({
            content: '操作失败!'
          });
        });
      },
      insertOrUpdateCustomer(customer) {
        const len = this.customers.length;
        let exist = false;
        let cur;
        let index = -1;
        this.preHandleCustomer(customer);
        for (let i = 0; i < len; i++) {
          cur = this.customers[i];
          if (cur.id === customer.id) {
            Object.assign(cur, customer);
            exist = true;
            index = i;
            break;
          }
        }
        if (this.params.quit === 0 && customer.quit && index > -1) {
          this.customers.splice(index, 1);
        }
        if (!exist) {
          this.customers.unshift(customer);
        }
      },
      studentExpireChange(date) {
        this.edit_customer.student_expire = date;
      },
      editCareer(customer) {
        this.edit_customer = Util.clone(customer);
        this.edit_career_config.modal = true;
      },
      addCareer() {
        this.edit_customer.careers.push(Util.clone(this.new_career));
      },
      delCareer(career, index) {
        if (career.id) {
          Util.ajax.post(Util.api.delete_career, {
            id: career.id
          }).then((response) => {
            return response.data;
          }).then((res) => {
            if (res.code === 1) {
              this.edit_customer.careers.splice(index, 1);
              this.$Message.success('删除成功!');
            } else {
              this.$Modal.error({
                title: '错误',
                content: res.msg
              });
            }
          }).catch((e) => {
            console.log(e);
            this.$Message.error('删除失败: ' + e);
          });
        } else {
          this.edit_customer.careers.splice(index, 1);
          this.$Message.success('删除成功!');
        }
      },
      formatCareerDate() {
        this.edit_customer.careers.forEach((career) => {
          ['entry_time', 'quit_time', 'contract_start', 'contract_end'].forEach((key) => {
            const date = career[key];
            if (date instanceof Date) {
              career[key] = DataUtil.format(date, 'yyyy-MM-dd');
            }
          });
        });
      },
      quitTimeChange(date) {
        console.log('选择了离职时间: ', date);
        if (date) {
          this.$Modal.warning({
            title: '提示',
            content: '如果员工已离职, 记得将员工状态设为离职哦!'
          });
        }
      },
      checkCareerValid() {
        return true;
        // let msg = '';
        // this.edit_customer.careers.forEach((career, index) => {
        //   if (!career.contract_start) {
        //     msg += `<p>合同${index + 1} 未设置[开始日期]</p>`;
        //   }
        //   if (!career.contract_end) {
        //     msg += `<p>合同${index + 1} 未设置[结束日期]</p>`;
        //   }
        //   if (career.contract_start && career.contract_end) {
        //     const start = new Date(career.contract_start).getTime();
        //     const end = new Date(career.contract_end).getTime();
        //     if (end < start) {
        //       msg += `合同${index + 1} [结束日期]不能早于[开始日期]`;
        //     }
        //   }
        // });
        // if (msg) {
        //   this.$Modal.error({
        //     title: '提示',
        //     content: msg
        //   });
        //   this.edit_career_config.loading = false;
        //   setTimeout(() => {
        //     this.edit_career_config.loading = true;
        //   }, 500);
        //   return false;
        // }
        // if (this.edit_customer.quit) {
        //   const len = this.edit_customer.careers.length;
        //   const lastCareer = this.edit_customer.careers[len - 1];
        //   if (!lastCareer.quit_time) {
        //     this.$Modal.error({
        //       title: '提示',
        //       content: '如果员工已离职, 请设置最后一次合同的离职时间.'
        //     });
        //     this.edit_career_config.loading = false;
        //     setTimeout(() => {
        //       this.edit_career_config.loading = true;
        //     }, 500);
        //     return false;
        //   }
        // }
        // return true;
      },
      editCareerOK() {
        if (this.checkCareerValid()) {
          this.formatCareerDate();
          Util.ajax.post(Util.api.update_customer_career, {
            customer_id: this.edit_customer.id,
            quit: this.edit_customer.quit,
            careers: this.edit_customer.careers
          }).then((response) => {
            return response.data;
          }).then((res) => {
            if (res.code === 1) {
              const data = res.data;
              this.preHandleCustomer(data);
              Util.insertOrUpdateArrayItem(this.customers, data);
              this.edit_career_config.modal = false;
            } else {
              this.edit_career_config.loading = false;
              setTimeout(() => {
                this.edit_career_config.loading = true;
              }, 500);
              this.$Modal.error({
                title: '错误',
                content: res.msg
              });
            }
          }).catch((e) => {
            this.edit_career_config.loading = false;
            setTimeout(() => {
              this.edit_career_config.loading = true;
            }, 500);
            console.log(e);
          });
        }
      },
      seeCustomerDetail(customer) {
        window.open('/hr/customer_detail/' + customer.id, '_blank');
        //this.$router.push('/hr/customer_detail/'+customer.id);
      }
    }
  }
</script>
